import { render, staticRenderFns } from "./PublicInvoice.vue?vue&type=template&id=57bedf05&scoped=true"
import script from "./PublicInvoice.vue?vue&type=script&lang=js"
export * from "./PublicInvoice.vue?vue&type=script&lang=js"
import style0 from "./PublicInvoice.vue?vue&type=style&index=0&id=57bedf05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bedf05",
  null
  
)

export default component.exports